import { render, staticRenderFns } from "./PurchasedButton.vue?vue&type=template&id=779060ba&scoped=true&"
import script from "./PurchasedButton.vue?vue&type=script&lang=js&"
export * from "./PurchasedButton.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedButton.vue?vue&type=style&index=0&id=779060ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779060ba",
  null
  
)

export default component.exports